<template>
    <gofix-card class="cardTable chartOfAccount" fullContent>
        <gofix-default-table
                :column-width-setting="columnWidthSetting"
                :settings="tableConfig"
                :table-items="tableItems"
                :column-setting-contract-id="general.contract_id"
                @load-items="getTableData"
                @new-item="showModalMassSchedule"
                @get-column-settings="getColumnSettings"
                @change-selected="changeSelectedTable"
                @export="exportItems"
                :tbody-tr-class="rowClass"
                ref="gofixTable">
            <template slot="gofix_table:after-control-left" slot-scope="data">
                <template v-if="settings.showBtnMassSchedule">
                    <gofix-button id="gofix-button-mass" class="ml-2" label="Mass Schedule" @click="showModalMassSchedule" outline></gofix-button>  
                    <gofix-button id="gofix-button-pre" class="ml-2" label="Pre-Assign Supplier" @click="assignItems" outline></gofix-button>
                    <gofix-button id="gofix-button-pre" class="ml-2" label="Import HDB Inspection" @click="modal.hdb_inspection.open = true" outline></gofix-button>
                    <b-tooltip target="gofix-button-mass" title="Mass Schedule"></b-tooltip>
                    <b-tooltip target="gofix-button-pre" title="Pre-Assign Supplier"></b-tooltip>
                </template>
            </template>
            <template slot="gofix_table:before-control-right" slot-scope="data" v-if="settings.showDropDownMaint">
                <div class="mr-2 d-flex align-items-center filterCompany filterMaint">
                    <span class="mr-1 title">Maint. Program</span>
                    <gofix-form-dropdown
                            :class="[ 'highlightDropdown chartOfAccountDropdown min-width-0', classInput ]"
                            label=""
                            vLabel="description_one"
                            :clearable="false"
                            :filterable="false" 
                            :options="maintPrograms"
                            v-model="maintProgram"
                            :placeholder="'Maint. Program'"
                            @search="searchMaintProgram">
                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                            <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                        </template>
                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                            <div class="maintOption">
                                <span>{{ option.description_one || '-' }}</span>
                            </div>
                        </template>
                    </gofix-form-dropdown>
                </div>
            </template>
            <template :slot="'gofix_table:' + field.key" slot-scope="row" v-if="field.key != 'actions'" v-for="field in columnSettings">
                <template v-if="field.key == 'name'">
                    {{ row.item.name }}
                </template>
                <template v-if="field.key == 'root_path'">
                   {{ row.item.root_path ? row.item.root_path : '--' }}
                </template>
                <template v-if="field.key == 'street_no'">
                   {{ row.item.street_no }}
                </template>
                <template v-if="field.key == 'street_name'">
                   {{ row.item.street_name }}
                </template>
                <template v-if="field.key == 'postal_code'">
                   {{ row.item.postal_code }}
                </template>
                <template v-if="field.key == 'last_activity'">
                    <template v-if="row.item.last_job && row.item.last_job.planned_date">
                        <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.last_job.client_contract_id}/maintenance-program/${row.item.last_job.maintenance_id}?tab=maint_schedule&contract_id=${row.item.last_job.client_contract_id}&schedule_id=${row.item.last_job.schedule_id}`">
                           <span class="text-decoration-underline">{{ row.item.last_job.planned_date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}</span>
                        </router-link>
                    </template>
                </template>
                <template v-if="field.key == 'upcoming_activity'">
                    <template v-if="row.item.coming_job && row.item.coming_job.planned_date">
                        <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.coming_job.client_contract_id}/maintenance-program/${row.item.coming_job.maintenance_id}?tab=maint_schedule&contract_id=${row.item.coming_job.client_contract_id}&schedule_id=${row.item.coming_job.schedule_id}`">
                           <span class="text-decoration-underline">{{ row.item.coming_job.planned_date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}</span>
                        </router-link>
                    </template>
                    <template v-else>
                        <gofix-button 
                            outline
                            class="btnUpcomingService" 
                            label="Schedule" 
                            :disabled="(
                                maintProgram && maintProgram.id != 'all' && 
                                (
                                    !property_ids.length ||
                                    (
                                        property_ids.length > 0 && !property_ids.includes(row.item.id)) || 
                                        row.item.coming_job != null
                                    )
                                )"
                            @click="showModalMassSchedule(row.item)"></gofix-button>
                    </template>
                </template>
                <template v-if="field.key == 'contractor'">
                    {{ row.item.coming_job && row.item.coming_job.supplier ? row.item.coming_job.supplier : '' }}
                </template>
                <template v-if="field.key == 'team_in_charge_name'">
                    {{ row.item.coming_job && row.item.coming_job.team_in_charge_name ? row.item.coming_job.team_in_charge_name : '' }}
                </template>
                <template v-if="field.key == 'staff_in_charge_name'">
                    {{ row.item.coming_job && row.item.coming_job.staff_in_charge_name ? row.item.coming_job.staff_in_charge_name : '' }}
                </template>
                <template v-if="field.key == 'type_abbreviation'">
                    {{ row.item.coming_job && row.item.coming_job.maintenance && row.item.coming_job.maintenance.abbreviation ? row.item.coming_job.maintenance.abbreviation : '' }}
                </template>
                <template v-if="field.key == 'maint_description'">
                    {{ row.item.coming_job && row.item.coming_job.maintenance && row.item.coming_job.maintenance.description_one ? row.item.coming_job.maintenance.description_one : '' }}
                </template>
            </template>
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open" @close="() => {
            this.modal.data.maintenance = null;
        }">
            <b-form class="pb-20">
                <gofix-form-dropdown
                    label="Maintenance Program"
                    vLabel="description_one"
                    :filterable="false" 
                    :append-to-body="true"
                    :options="popupMaintPrograms"
                    v-model="modal.data.maintenance"
                    placeholder=" "
                    @search="searchMaintProgram">
                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                        <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                    </template>
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        <div class="maintOption">
                            <span>{{ option.description_one || '-' }}</span>
                        </div>
                    </template>
                </gofix-form-dropdown>
                <gofix-form-properties
                        label="Location"
                        :contract-id="general.contract_id"
                        :property-id="general.root_property_id"
                        :valueFormat="'object'"
                        :multiple="true"
                        :flat="true"
                        showIconRequired
                        v-model="modal.data.property_list">
                </gofix-form-properties>
                <gofix-form-input-date
                    v-model="modal.data.date"
                    label="Date">
                </gofix-form-input-date>
                <template>
                    <b-form-checkbox v-model="modal.data.is_create_individual" class="checkbox-main-allow"><span class="ml-2">Create individual schedule for each location</span></b-form-checkbox>
                </template>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="checkScheduledJob" :disabled="property_loading" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!--Modals-->
        <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="assign to" hide-footer :centered="true" v-model="modal.assign.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown label="Choose FM Team" vLabel="group_name"
                            :options="fm_group_options" 
                            v-model="modal.assign.team_in_charge"
                             @change="FMTeamChange"
                            >
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Choose FM Staff"
                            vLabel="user_name"
                            v-model="modal.assign.staff_in_charge"
                            :options="fm_staff_options"
                            @search="getFMStaff" 
                            v-bind:class="{'run-loading small-loading':modal.assign.loading_fm_staff}"
                            >
                        <template #gofixInput:dropdown:option="{ user_name, role_name }">
                                {{ user_name }} {{ (role_name ? "-" : "")}} {{ role_name }}
                        </template>
                        <template #gofixInput:dropdown:selected-option="{ user_name, role_name }">
                            {{ user_name }} {{ (role_name ? "-" : "")}} {{ role_name }}
                        </template>
                    </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <gofix-form-supplier
                                label="Choose Supplier"
                                :contract-id="modal.assign.contract_id"
                                :required="true"
                                v-model="modal.assign.supplierAssign">
                        </gofix-form-supplier>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="assignSupplier" :loading="modal.assign.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!-- Modal Schedule Job -->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modal.checkSchedule.open">
            <div class="center">These location already had<br><strong>a schedule</strong></div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modal.checkSchedule.open = false">Cancel</b-button>
                <b-button class="custom-btn" @click="createPropertySchedule">Override</b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" @hide="resetImport" title="import file" id="modal-Import" hide-footer v-model="modal.hdb_inspection.open">
            <b-form>
                <b-form-group>
                    <b-form-file @input="changeFile" placeholder="Click Browse to upload file" :state="modal.hdb_inspection.check" ref="file-input-bdj" accept=".csv" v-model="modal.hdb_inspection.file" >
                        <template slot="file-name" slot-scope="{ names }">
                        <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                        </template>
                    </b-form-file>
                </b-form-group>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="importHDBInspection" :loading="modal.hdb_inspection.loading"  noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modal.export.title" hide-footer :centered="true" v-model="modal.export.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
            <b-progress-bar :value="100">
                <span class="font-size-16">{{modal.export.process}}</span>
            </b-progress-bar>
            </b-progress>
        </b-modal>
    </gofix-card>
</template>

<script>
    import { mapGetters } from "vuex";
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';

    export default {
        name: "property-schedule",
        props: {
            nameTable: {
                type: String,
                default: "preventive-maintenance-property-schedule"
            },
            settings: {
                type: Object,
                default: {
                    showBtnMassSchedule: false,
                    showDropDownMaint: false,
                    create: false
                }
            },
            general: {
                type: Object,
                default: {
                    contract_id: null,
                    contract_term_id: null,
                    property_id: null,
                }
            },
            maintData: {
                type: Object,
                default: null
            }
        },
        components: {
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['property_schedule']));
            return {
                columnWidthSetting:
                {
                    leftWidth:5,
                    rightWidth:7
                },
                columnSettings: [],
                tableConfig:{
                    dataSelect: {
                        certificate_expiry_month: {
                            value: [
                                {value: 'Jan', text: 'Jan'},
                                {value: 'Feb', text: 'Feb'},
                                {value: 'Mar', text: 'Mar'},
                                {value: 'Apr', text: 'Apr'},
                                {value: 'May', text: 'May'},
                                {value: 'Jun', text: 'Jun'},
                                {value: 'Jul', text: 'Jul'},
                                {value: 'Aug', text: 'Aug'},
                                {value: 'Sep', text: 'Sep'},
                                {value: 'Oct', text: 'Oct'},
                                {value: 'Nov', text: 'Nov'},
                                {value: 'Dec', text: 'Dec'}
                            ],
                            value_field: 'value',
                            text_field: 'text'
                        }
                    },
                    name: this.nameTable,
                    controls:{
                        create: false,
                        delete: false,
                        tableExport: true,
                        tableImport: false,
                    },
                    filter: filter,
                    buildFilter: true,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "root_path",
                    sortDirection: "asc",
                    fields: [{
                                key: "actions",
                                label: "",
                                thStyle: "width:65px"
                            }, {
                                key: "name",
                                label: "Location",
                                thStyle: "width:150px",
                                isActive: true,
                                isFilter: true
                            }, {
                                key: "root_path",
                                label: "Location Path",
                                thStyle: "width:250px",
                                isActive: true,
                                isFilter: true
                            }, {
                                key: "street_no",
                                label: "Street No",
                                thStyle: "width:75px",
                                isActive: true,
                                isFilter: true
                            }, {
                                key: "street_name",
                                label: "Street Name",
                                thStyle: "width:200px",
                                isActive: true,
                                isFilter: true
                            }, {
                                key: "postal_code",
                                label: "Postal Code",
                                thStyle: "width:100px",
                                isActive: true,
                                isFilter: true
                            }, {
                                key: "last_activity",
                                label: "Last Activity",
                                thStyle: "width:250px"
                            }, {
                                key: "upcoming_activity",
                                label: "Upcoming Activity",
                                thStyle: "width:250px"
                            }, {
                                key: "lettable",
                                label: "Lettable",
                                thStyle: "width:90px"
                            }
                        ]
                },
                tableItems:[],
                property_ids: [],
                properties: [],
                property_loading: false,
                pagesProperties: {
                    isCMS: '1',
                    limit: 100,
                    page: 1,
                    totalPage: 0,
                    filter: JSON.parse(JSON.stringify(filters['property_schedule']))
                },
                property: null,
                showFieldLocation: false,
                maintProgram: {
                    id: 'all',
                    description_one: 'All'
                },
                maintPrograms: [],
                popupMaintPrograms: [],
                isAction: false,
                fileImport: null,
                fileName: 'Click Browse to upload file',
                isCheckImport: false,
                job_id:null,
                fm_staff_options: [],
                fm_group_options: [],
                timer: {
                    fm_staff: null,
                },
                modal:{
                    title: 'Property Maintenance Schedule',
                    open: false,
                    loading: false,
                    status:false,
                    ids: [],
                    properties:[],
                    property_ids: [],
                    data: {
                        maintenance_id: null,
                        client_contract_id: null,
                        date: null,
                        property_list: [],
                        maintenance: null,
                        is_create_individual: false,
                    },
                    assign:{
                        open:false,
                        loading: false,
                        clients:[],
                        generate_order:false,
                        supplierAssign: null,
                        optionsSupplier: [],
                        tierLevel: 1,
                        ids: [],
                        tiers: [],
                        filter: null,
                        time: null,
                        job_id:null,
                        contract_id: null,
                        property_list:null,
                        staff_in_charge: null,
                        team_in_charge: null,
                        loading_fm_staff: false,
                        service_category_ids: [],
                    },
                    checkSchedule: {
                        open: false,
                    },
                    hdb_inspection: {
                        open: false,
                        loading: false,
                        check: '',
                        file: null,
                        fileName: "Click Browse to upload file",
                        supplier: null,
                        supplier_id: null,
                    },
                    export: {
                        open: false,
                        loading: false,
                        process: 'Importing file',
                        title: 'Import Data'
                    }
                },
                timer: {
                    maint: null,
                    modal: null,
                    property: null
                },
                tierLevel: 1,
                classInput: "width-175",
                innerWidth: 0,
                modalImport:{
                open:false,
                loading: false,
                check:'',
                file:null,
                fileName: "Click Browse to upload file"
              }
            }
        },
        filters: {
            displayFollowCustomField: function(val, key_tmp, formatDate = "DD/MM/YYYY") {
                if(val) {
                    let arr = val;
                    let type_name = key_tmp.replaceAll('_', ' ');
                    type_name = type_name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                    let filter = arr.filter(item => item.name == type_name);
                    if(filter.length > 0) {
                        if(filter[0].value) {
                             if(filter[0].type == 'DateTime') {
                                return moment(new Date(filter[0].value)).format(formatDate)
                            }
                            return filter[0].value;
                        }
                    }
                }
                return;
            },
          getCustomValue: function (value, key,type) {
            if (value && Array.isArray(value)) {
              for (var i = 0; i < value.length; i++) {
                if (value[i].attribute_id === key) {
                  if(type === "DateTime"){
                    if(value[i].value){
                      return moment(value[i].value, "YYYY-MM-DD").format("DD.MM.YYYY");
                    }
                  }
                  return value[i].value;
                }
              }
            } else {
              return "";
            }
          }
        },
        watch: {
            property: function(val) {
                if(val) {
                    this.getProperties(val.id);
                }
            },
            maintData: function(val) {
                if(val) {
                    this.maintProgram = JSON.parse(JSON.stringify(val));
                }
            },
            maintProgram: function(val) {
                if(val && val.id != 'all') {
                    if(!this.settings.showDropDownMaint) {
                        this.general.property_id = val.property_id;
                    }

                    this.$refs.gofixTable.reloadTableKeepFilter();
                } else {
                    this.properties = [];
                    this.property_ids = [];
                    this.reloadProperty();
                }

                if(this.settings.showDropDownMaint) {
                    this.$emit("change-maint", val);
                }
            },
            "modal.data.maintenance": function(val, old) {
                if(val && ( (this.maintProgram && this.maintProgram.id == 'all') || old ) ) {
                    this.getProperties();
                }
            },
            "general.contract_id": function(val) {
                this.maintProgram = null;
                if(val) {
                    this.getProperties();
                    this.reloadProperty();
                }
            },
            "general.contract_term_id": async function(val) {
                if(val && this.settings.showDropDownMaint) {
                    await this.getMaintProgram();
                    this.maintProgram = await {
                        id: 'all',
                        description_one: 'All'
                    };
                } else {
                    this.maintPrograms = [];
                }
            },
            "general.property_id": function(val) {
                if(val) {
                    this.getProperties();
                    this.reloadProperty();
                }
            },
            innerWidth: function(val) {
                this.$nextTick(() => { 
                    if(val <= 1680) {
                        this.$root.$emit('bv::enable::tooltip', 'gofix-button-mass');
                        this.$root.$emit('bv::enable::tooltip', 'gofix-button-pre');
                        this.$root.$emit('bv::enable::tooltip', 'gofix-button-download');
                    } else {
                        this.$root.$emit('bv::disable::tooltip', 'gofix-button-mass');
                        this.$root.$emit('bv::disable::tooltip', 'gofix-button-pre');
                        this.$root.$emit('bv::disable::tooltip', 'gofix-button-download');
                    }
                });
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: "ContractController/ClientContractID"
            })
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        created() {
            this.tableConfig.controls.create = this.settings.create;
            if(this.settings.title_modal) {
                this.modal.title = this.settings.title_modal
            }
            if(this.general.contract_term_id && this.settings.showDropDownMaint) {
                this.getMaintProgram();
            }

            if(this.maintData) {
                this.maintProgram = JSON.parse(JSON.stringify(this.maintData));
            }
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            changeSelectedTable(val) {
                this.modal.ids = val.map(item => item.id);
                this.modal.properties = val;
            },
            downloadReport(){
                if(this.modal.properties.length === 0){
                    return this.$alertNotification("Please select a record!", "danger");
                }
                let properties = this.modal.properties;
                var job = [];
                properties.forEach(function(item) {
                    if(item.coming_job_annual){
                        job.push(item.coming_job_annual.id);
                    }
                    if(item.coming_job_five_year){
                        job.push(item.coming_job_five_year.id);
                    }
                    if(item.last_job_annual){
                        job.push(item.last_job_annual.id);
                    }
                    if(item.last_job_five_year){
                        job.push(item.last_job_five_year.id);
                    }
                });
                if(job.length === 0){
                    return this.$alertNotification("No available job for report", "danger");
                }
                var nameFile = `report-${moment().format('DD-MMM-YYYY')}.zip`;
                this.$store.dispatch("JobController/reportJob", {
                    id: job,
                    mutil_file: true,
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile);
                    document.body.appendChild(link);
                    link.click();
                });
            },
            handleResize() {
                this.innerWidth = window.innerWidth;
                this.classInput = "width-175";
                if (window.innerWidth < 1500) {
                    this.classInput = "width-99"
                }
            },
            getColumnSettings(settings){
                this.columnSettings = settings;
            },
            getSupplier(){
                this.$store.dispatch("MiscExpensesController/getRelateSupplier",{
                    contract_id:this.modal.assign.contract_id,
                    filter:null
                })
                    .then(response => {
                        this.modal.assign.tiers = response;
                        if(response.tier_1){
                            this.modal.assign.optionsSupplier = response.tier_1;
                            this.modal.assign.tierLevel = 1;
                        }else if(response.tier_2){
                            this.modal.assign.optionsSupplier = response.tier_2;
                            this.modal.assign.tierLevel = 2;
                        }else if(response.tier_3){
                            this.modal.assign.optionsSupplier = response.tier_3;
                            this.modal.assign.tierLevel = 3;
                        }
                    })
                    .catch( err => {
                        console.log(err)
                    })
            },
            showMoreSupplier(){
                switch (this.tierLevel) {
                    case 1:
                        this.modal.assign.supplier = this.modal.assign.supplier.concat(this.tiers.tier_2);
                        this.tierLevel = 2;
                        break;
                    case 2:
                        this.modal.assign.supplier = this.modal.assign.supplier.concat(this.tiers.tier_3);
                        this.tierLevel = 3;
                        break;
                }
            },
            async assignItems(){
                this.modal.assign.job_id = null;
                if(this.modal.ids.length === 0){
                    return this.$alertNotification("Please select a record!", "danger");
                }
                this.modal.assign.ids = this.modal.ids;
                let property_ids = this.modal.assign.ids;
                let properties = this.modal.assign.job_id = this.tableItems.filter(element => 
                    (
                        (property_ids.indexOf(element.id)!== -1) && !element.order_id && element.coming_job != null
                    )
                );

                if(properties.length !== property_ids.length){
                    return this.$alertNotification("Please select a location with upcoming service!", "danger");
                }

                let job_ids = [];
                let service_category_ids=[];
                properties.map(item => {
                    if(item.coming_job && item.coming_job.id) {
                        job_ids.push(item.coming_job.id);
                        service_category_ids.push(item.coming_job.service_category_id);
                    }
                })
                this.modal.assign.job_id = job_ids;
                this.modal.assign.open = true;
                this.modal.assign.contract_id = (this.ClientContractID && this.ClientContractID.id) ? this.ClientContractID.id:null
                this.modal.assign.tierLevel = 1;
                this.modal.assign.service_category_ids = service_category_ids;
                this.getSupplier();
                this.getFMTeam();
                this.getFMStaff();
            },
            assignSupplier(){
                if (this.modal.assign.supplierAssign == null && !this.modal.assign.staff_in_charge  && !this.modal.assign.team_in_charge) {
                    return this.$alertNotification("Please select a supplier or FM team or FM staff!", "primary");
                }
                this.modal.assign.loading = true;
                this.$store.dispatch("JobController/assignRunsheetSupplier", {
                    ids: this.modal.assign.job_id,
                    supplier: this.modal.assign.supplierAssign,
                    generate_order: this.modal.assign.generate_order,
                    filter: this.modal.assign.filter,
                    staff_in_charge_id: this.modal.assign.staff_in_charge ? this.modal.assign.staff_in_charge.user_id : null,
                    staff_in_charge_name: this.modal.assign.staff_in_charge ? this.modal.assign.staff_in_charge.user_name : null,
                    team_in_charge_id: this.modal.assign.team_in_charge ? this.modal.assign.team_in_charge.id : null,
                    team_in_charge_name: this.modal.assign.team_in_charge ? this.modal.assign.team_in_charge.group_name : null,
                }).then(response => {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.modal.assign.supplierAssign = null;
                    this.modal.assign.generate_order = false;
                    this.modal.assign.open = false;
                    this.modal.assign.loading = false;
                    if (response.data.data.code === 200) {
                        return this.$alertNotification(this.$notificationV2("editing", "job_list_soft_fm"));
                    }
                })
                .catch(err => {
                    this.modal.assign.loading = false;
                    if(this.modal.assign.generate_order) {
                        return this.$alertNotification("Create Order failed. Line Items empty!", "danger");
                    }
                })
            },
            checkSchedule() {
                if(!this.modal.data.maintenance || !this.modal.data.property_list.length) return false;
                return this.modal.data.property_list.some(item => !this.modal.property_ids.includes(item.id));
            },
            showModalMassSchedule(item = null, type = '') {
                this.popupMaintPrograms     = this.maintPrograms.filter(item => item.id != 'all');
                this.modal.data.maintenance = this.maintProgram.id != 'all' ? this.maintProgram : null;
                
                if(item) {
                    this.property = JSON.parse(JSON.stringify(item));
                    this.modal.data.property_list = [{
                        id: item.id,
                        name: item.name
                    }];
                } else {
                    this.modal.data.property_list = this.tableItems.filter(item => this.modal.ids.includes(item.id)).map(function(item) {
                        return {
                            id: item.id,
                            name: item.name
                        }
                    });
                    //if(this.maintProgram.location_info) this.property = JSON.parse(JSON.stringify(this.maintProgram.location_info));
                }

                //check: allow schedule
                if(!item) {
                    if(this.checkSchedule()) {
                        return this.$alertNotification("Scheduling is not possible because some rows are not part of the maintenance program you choose.", "danger");
                    }
                }

                this.modal.data.date = null;
                this.modal.status = false;
                this.modal.data.is_create_individual = false;
                this.job_id = null;

                this.general.root_property_id = this.maintProgram.property_id;
                this.modal.data.client_contract_id = this.general.contract_id;
                this.modal.loading = false;
                this.modal.open = true;
            },
            async getMaintProgram(search = null, is_popup = false) {
                let filters = {
                    search:             search,
                    contract_term_id:   this.general.contract_term_id,
                    is_maintenance:     true,
                    is_master:          false,
                    is_equipment_group_empty: true
                }
                
                await this.$store.dispatch("v2SorController/getItems", {
                    isCMS: false,
                    page: -1,
                    limit: 100,
                    group_id: 0,
                    filter: filters
                })
                .then(response => {
                    if(!is_popup) {
                        this.maintPrograms = [{
                            id: 'all',
                            description_one: 'All'
                        }].concat(response.items);
                    } else {
                        this.popupMaintPrograms = response.items;
                    }
                })
                .catch(err => {
                    this.maintPrograms = [];
                })
            },
            async searchMaintProgram(search, loading) {
                loading(true)
                this.maintPrograms = []
                if (this.timer.maint) {
                    clearTimeout(this.timer.maint);
                    this.timer.maint = null;
                }
                this.timer.maint = setTimeout(async () => {
                    try {

                        let is_popup = false;
                        if(this.modal.open)
                            is_popup = true;

                        await this.getMaintProgram(search, is_popup);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            checkScheduledJob() {
                if(!this.modal.data.property_list.length) {
                    return this.$alertNotification("Location(s) is required", "danger");
                }

                if(!this.modal.data.maintenance) {
                    return this.$alertNotification("Maintenance program is required", "danger");
                }

                if(!this.modal.data.date) {
                    return this.$alertNotification("Date is required", "danger");
                }

                if(moment(this.modal.data.date).isBefore(moment(), 'day')) {
                    return this.$alertNotification("The date must be greater than or equal to the current date.", "danger");
                }

                if(this.checkSchedule()) {
                    return this.$alertNotification("Scheduling is not possible because some location are not part of the maintenance program you choose.", "danger");
                }

                let request = {
                    property_list: this.modal.data.property_list,
                    maintenance_id: this.modal.data.maintenance.id,
                    planned_date:   moment(this.modal.data.date).format('YYYY-MM-DD')
                }
                if (this.timer.modal) {
                    clearTimeout(this.timer.modal);
                    this.timer.modal = null;
                }
                this.timer.modal = setTimeout(async () => {
                    this.$store.dispatch("PropertyController/checkPropertyScheduledJob", request)
                    .then(response => {
                        let result = response.data.data;
                        if(!result.existing) {
                            this.createPropertySchedule();
                            return;
                        }

                        this.modal.checkSchedule.open = true;
                    })
                    .catch(err => {
                        console.log(err);
                    })
                }, 200);
            },
            createPropertySchedule() {
                this.modal.loading = true;
                this.modal.checkSchedule.open = false;
                this.modal.data.maintenance_id = this.modal.data.maintenance.id;
                let objeClone = JSON.parse(JSON.stringify(this.modal.data));
                objeClone.start_date = moment(objeClone.date).format('YYYY-MM-DD');
                objeClone.end_date = moment(objeClone.date).format('YYYY-MM-DD');
                objeClone.property_list = JSON.stringify(
                    objeClone.property_list.map(item => {
                        return {
                                id: item.id,
                                name: item.name
                            };
                        })
                    );
                
                if(this.job_id){
                    this.$store.dispatch("JobController/updatePlannedDateRunsheet", {
                        data: {
                            date: objeClone.start_date
                        },
                        id: this.job_id,
                    }).then((result) => {
                        this.modal.open = false;
                        this.getProperties();
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2("editing", "job_list_soft_fm"));
                    })
                    .catch((err) => {
                        this.modal.loading = false;
                    });
                    return;
                }
                this.$store.dispatch("PropertyController/createPropertySchedule", objeClone)
                .then(response => {
                    this.modal.open = false;
                    this.getProperties();
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.$alertNotification(this.$notificationV2('adding', 'job_list_soft_fm'));
                })
                .catch(err => {
                    this.modal.loading = false;
                })
            },
            // /* --- Properties --- */
            async getProperties(property_id = "", search = "") {
                if(this.general.contract_id) {
                    this.property_loading = true;
                    this.pagesProperties.property_schedule = true;
                    this.pagesProperties.filter.name.value = search;
                    this.pagesProperties.property_id = property_id || this.general.property_id;
                    this.pagesProperties.contract_id = this.general.contract_id;

                    if(this.modal.data.maintenance) {
                        this.pagesProperties.maintenance_id = this.modal.data.maintenance.id;
                        this.pagesProperties.maintenance_property_id = this.modal.data.maintenance.property_id;
                    } else if(this.maintProgram) {
                        this.pagesProperties.maintenance_id = this.maintProgram.id;
                        this.pagesProperties.maintenance_property_id = this.maintProgram.property_id;
                    }
                    
                    await this.$store.dispatch("PropertyController/getListLocations", this.pagesProperties)
                    .then(response => {
                        this.property_loading = false;
                        this.properties = response.data.data.items;
                        this.property_ids = [];
                        this.modal.property_ids = [];
                        if(response.data.data.property_ids) {
                            this.property_ids = this.modal.property_ids = response.data.data.property_ids;
                        }
                    })
                    .catch(err => {
                        this.property_loading = false;
                        this.$alertNotification("Can not load the locations", "danger");
                    });
                }
            },
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                if(!this.general.contract_id) {
                    this.tableItems = [];
                    resolve({
                        items: [],
                        total: 0
                    });
                    return;
                }

                tableRequest.contract_id = this.general.contract_id;
                tableRequest.property_id = this.general.property_id;
                tableRequest.property_schedule = true;
                tableRequest.maintenance_id = this.maintProgram ? this.maintProgram.id : null;
                
                if(this.settings.showDropDownMaint) {
                    tableRequest.maintenance_property_id = this.maintProgram && this.maintProgram.property_id ? this.maintProgram.property_id : null;
                }

                if(tableRequest.property_id) {
                    await this.$store.dispatch("PropertyController/getListLocations", tableRequest)
                        .then(response => {
                            this.tableItems = response.data.data.items;
                            this.tableConfig.total = response.data.data.total;
                            this.property_ids = [];
                            this.modal.property_ids = [];
                            if(response.data.data.property_ids) {
                                this.property_ids = this.modal.property_ids = response.data.data.property_ids;
                            }
                            resolve(response.data.data);
                        })
                        .catch(err => {
                            this.$alertNotification("Can not load the locations", "danger");
                            reject();
                        });
                } 
                else {
                    reject();
                }
            },
            reloadProperty() {
                this.$refs.gofixTable.reloadTableItems();
            },
            /*--- Export File ---*/
            exportItems(tableRequest) {
                if(!this.general.contract_id) {
                    return;
                }
                tableRequest.contract_id = this.general.contract_id;
                tableRequest.property_id = this.general.property_id;
                tableRequest.property_schedule = true;
                tableRequest.maintenance_id = this.maintProgram ? this.maintProgram.id : null;
                tableRequest.limit = -1;

                if(tableRequest.property_id) {
                    this.$store.dispatch( 'PropertyController/exportPropertySchedule', tableRequest)
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'JobListSoftFM.csv'); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                    })
                } 
            },
            getFMTeam() {
                this.fm_group_options = [];
                this.$store.dispatch("UserGroupController/getItems", {
                        page: 1,
                        limit: -1,
                        filter: {
                            contract_id: this.modal.assign.contract_id
                        }
                    })
                    .then(response => {
                        this.fm_group_options = response.items;
                    })
                    .catch(err => {
                        this.fm_group_options = [];
                    })
            },
            getFMStaff(search) {
                this.fm_staff_options = [];
                this.modal.assign.loading_fm_staff = true;
                if (this.timer.fm_staff) {
                    clearTimeout(this.timer.fm_staff);
                    this.timer.fm_staff = null;
                }
                this.timer.fm_staff = setTimeout(() => {
                    var params = {
                            contract_id: this.modal.assign.contract_id,
                            property_ids: this.modal.assign.ids ? this.modal.assign.ids : null,
                            service_category_ids: this.modal.assign.service_category_ids ? this.modal.assign.service_category_ids : null,
                            section_name: ["Preventive Maintenance"],
                            module_name: ["Job List"],
                            filter: {
                                name: search || null
                            }
                        };
                    if(this.modal.assign.team_in_charge){
                        params.group_id = this.modal.assign.team_in_charge.id;
                    }
                    this.$store.dispatch("v2UserController/getAccessRunsheetFmUsers", params)
                        .then(response => {
                            this.fm_staff_options = response.items;
                            this.modal.assign.loading_fm_staff = false;
                        })
                        .catch(err => {
                            this.modal.assign.loading_fm_staff = false
                        })
                }, 500);
            },
            FMTeamChange(id){
                this.modal.assign.staff_in_charge = null;
                this.fm_staff_options = [];
                this.getFMStaff();
            },
            rowClass(item, type) {
                if (item) {
                    if (item.color === true) {
                        return 'row-case-new';
                    }
                }
                return null;
            },
            resetImport(){
                this.modal.hdb_inspection.check = '';
                this.modal.hdb_inspection.file = null;
            },
            changeFile(){
                this.modal.hdb_inspection.check = this.modal.hdb_inspection.file ? false : true;
            },
            async importHDBInspection() {
                if(this.modal.hdb_inspection.loading) return ;
                if (!this.modal.hdb_inspection.file) {
                    return this.$alertNotification("Please choose file to import", "danger");
                }
                
                this.modal.hdb_inspection.open = false;
                this.modal.hdb_inspection.loading = false;
                this.modal.export.open = true;
                this.modal.export.process = "Importing file";

                await this.$store.dispatch(`PropertyController/importHDBInspection`, {
                    contract_id: (this.ClientContractID && this.ClientContractID.id) ? this.ClientContractID.id : null,
                    file: this.modal.hdb_inspection.file
                })
                .then(response => {
                    let variant = 'success';
                    let msg = 'Successfully imported HDB Inspection';
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                        variant = 'danger';
                        msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }
                    this.$alertNotification(msg, variant);
                    this.modal.export.open = false;
                    

                    this.$emit('loadProperty');
                    this.$refs.gofixTable.reloadTableItems();
                })
                .catch(err => {
                    this.modal.export.open = false;
                    let msg = "Can't import data!";
                    if( err.response.data.error && err.response.data.error.message ){
                        msg = err.response.data.error.message;
                    }
                    return this.$alertNotification(msg, "danger");
                });
            }
        }
    }
</script>